import { Currency } from '@/core/currency/interfaces';

const AMD: Currency = {
    name: 'Armenian Dram',
    demonym: 'Armenian',
    majorSingle: 'Dram',
    majorPlural: 'Dram',
    codeNumeric: '051',
    symbol: '֏',
    symbolNative: 'դր',
    minorSingle: 'Luma',
    minorPlural: 'Luma',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'AMD',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default AMD;
